<script setup>
import { onMounted, computed } from 'vue';
import { useGraficoPastasAptosParaApreensaoPorRegional } from '~/composables/pastas/useGraficoPastasAptosParaApreensaoPorRegional';
import { colors } from '~/utils';

const {
  status: graficoPastasAptosParaApreensaoPorRegionalStatus,
  data: graficoPastasAptosParaApreensaoPorRegionalData,
  runAsync: graficoPastasAptosParaApreensaoPorRegionalAsync,
} = useGraficoPastasAptosParaApreensaoPorRegional();

const chartOptions = computed(() => {
  if (graficoPastasAptosParaApreensaoPorRegionalStatus.value !== 'success') {
    return null;
  }
  return {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      animations: {
        enabled: false,
      },
    },
    colors,
    plotOptions: {
      bar: {
        distributed: true,
      },
    },
    series: [
      {
        name: 'total',
        data: graficoPastasAptosParaApreensaoPorRegionalData.value.items.map(
          (x) => x.value
        ),
      },
    ],
    xaxis: {
      categories:
        graficoPastasAptosParaApreensaoPorRegionalData.value.items.map((x) =>
          x.label.toUpperCase()
        ),
      labels: {
        show: false,
      },
    },
  };
});

onMounted(async () => {
  await graficoPastasAptosParaApreensaoPorRegionalAsync();
});
</script>

<template>
  <ChartCard
    :status="graficoPastasAptosParaApreensaoPorRegionalStatus"
    :options="chartOptions"
  >
    <template #title>
      <span style="color: rgb(128 128 128); font-size: 16px"
        >TOTAL PASTAS APTAS PARA APREENSÃO POR REGIONAL</span
      >
    </template>
  </ChartCard>
</template>
